import React from 'react';

const DashboardStatsCard = ({ title, value, valueTextColorClass, cardBgColorClass, isSelected, onClick }) => {
  const selectedClass = isSelected ? 'ring-2 ring-offset-2 ring-black' : ''; // Indicador visual de selección
  const cursorClass = onClick ? 'cursor-pointer hover:shadow-xl' : ''; // Cursor y sombra al pasar el mouse

  return (
    <div
      className={`${cardBgColorClass} p-4 rounded-2xl shadow-lg flex flex-col items-center justify-center transition-all duration-300 ${selectedClass} ${cursorClass}`}
      onClick={onClick}
    >
      <h3 className="text-base font-semibold text-gray-600 mb-1">{title}</h3>
      <p className={`text-4xl font-extrabold ${valueTextColorClass}`}>{value}</p>
    </div>
  );
};

export default DashboardStatsCard;